module.exports = __webpack_public_path__ + "static/media/04_gazetanoticias_mobile.8bb4ad8f.jpg";